import { PageIndices } from '../../common/i-doc/i-doc.registry.ts';
import React from 'react';
import { Box } from '@mui/material';
import { PageHint } from '../common/PageHint';
import { ExpertAppointmentsList } from '../appointments/expert/ExpertAppointmentsList';

interface ClientAppointmentsTabProps {
  clientId: string;
}

export const ClientAppointmentsTab: React.FC<ClientAppointmentsTabProps> = ({ clientId }) => {
  return (
    <Box data-i-doc={PageIndices.EXPERT_CLIENT_APPOINTMENTS}>
      <PageHint iDoc={PageIndices.EXPERT_CLIENT_APPOINTMENTS} />
      <ExpertAppointmentsList clientId={Number(clientId)} />
    </Box>
  );
};
